module.exports = flarum.core.compat['states/GlobalSearchState'];